module.exports = __webpack_public_path__ + "static/media/next1.eac1b0fb.svg";